import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TeacherAllotmentService {
  constructor(public http: HttpClient) {}

  getSectionSubjects(sectionId: number) {
    return this.http.get('../../../assets/api/sectionSubjects.json');
  }
}
